import { AlertTriangle } from 'lucide-react';
import { cn } from '../../lib/utils.js';
/**
 * Displays a visually appealing loading error message.
 */
export var LoadingError = function (_a) {
    var _b = _a.message, message = _b === void 0 ? (<div>
      Uh oh! Something unexpected happened.
      <br />
      Please check your internet connection and try again.
    </div>) : _b, className = _a.className;
    return (<div role="alert" aria-live="assertive" className={cn('border-destructive bg-destructive/10 text-destructive mx-auto flex w-full max-w-2xl flex-col items-center justify-center rounded-md border p-8 shadow-sm', className)}>
    <AlertTriangle className="mb-3 h-10 w-10" aria-hidden="true"/>
    <div className="w-full text-center text-lg font-medium wrap-break-word">{message}</div>
  </div>);
};
